const InfoCard = props => {
  const {
    image,
    altText,
    title,
    description,
    link,
    linkText = 'Read more',
  } = props
  return (
    <div className="bg-grey-light rounded-sm shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden h-full flex flex-col">
      <div className="p-8 flex items-center justify-center h-32">
        <img
          src={image}
          alt={altText}
          className="max-w-32 max-h-20 min-w-16 min-h-8 object-contain"
        />
      </div>
      <div className="p-6 flex-1 flex flex-col">
        <h2
          dangerouslySetInnerHTML={{ __html: title }}
          className="text-blue-dark text-xl font-extralight tracking-tight leading-tight mb-4 flex-shrink-0"
        ></h2>
        <p
          dangerouslySetInnerHTML={{ __html: description }}
          className="text-grey text-sm leading-relaxed mb-6 flex-1 line-clamp-4 overflow-hidden"
        ></p>
        <a
          href={link}
          target="_blank"
          rel="noreferrer"
          className="text-blue hover:text-blue-light font-bold text-sm font-[sans-serif] inline-flex items-center mt-auto"
        >
          {linkText} &#8594;
        </a>
      </div>
    </div>
  )
}

export default InfoCard
